import React, { useState, useEffect } from 'react'
import SectionHeader from '../components/ui/sectionHeader/SectionHeader'
import redXIcon from '../components/ui/planbutton/img/redXIcon.png'
import chatUs from '../assets/images/chatUs.svg'
import call from '../assets/images/call.svg'
import './paymentSuccessfulStyle.scss'
import { useDispatch, useSelector } from 'react-redux';
import { getTransDtls } from '../components/JsonToSoapXml/getTransDtls'
import { getTransDtlsSoap } from '../components/SoapXmlToJson/getTransDtlsSoap'
import { useNavigate } from 'react-router-dom';
import LoadingMask from '../components/loadingMask/LoadingMask'
import { getValidAccessToken } from '../services/oauthservice.js'
import axios from 'axios';
import { createApiLog } from '../helpers/apiLogger.js'
import { updateJourneyLog } from '../helpers/journeyLogger.js'
import { encryptRSA } from '../services/encrypt.js'

export default function PaymentUnsuccessful() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading } = useSelector(state => state.loadingReducer);
    const { partnerConfig } = useSelector((state) => state.partnerConfig || {});
    const { SRC_BUS_ID = 'CP', PARTNER_ID } = partnerConfig || {};

    const [pgFailedData, setPgFailedData] = useState();
    const [transDtls, SetTransDtls] = useState();
    const [quoteData, setQuoteData] = useState(null);

    useEffect(() => {
        const fetchFailedPaymentResponse = async () => {
            const br = new URLSearchParams(window.location.search).get('br');
            if (!br) return;

            try {
                const token = await getValidAccessToken();

                const response = await fetch(
                    `${process.env.REACT_APP_DIC_ADMIN_API}/v1/payments/payment-responses?br=${encodeURIComponent(br)}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        }
                    }
                );

                const result = await response.json();

                const data = result.data;
                setPgFailedData(data);

                await createApiLog({
                    PARTNER_ID: PARTNER_ID,
                    APP_ID: 1,
                    COB: "MOTOR",
                    TRANS_ID: quoteData?.TRANS_ID,
                    API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/payments/payment-responses?br=${encodeURIComponent(br)}`,
                    REQUEST: br,
                    REQUEST_STATUS: "Success",
                    RESPONSE: result,
                })

                const quoteNo = data.mer_param_2
                const quoteRes = await fetch(
                    `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes/byQuoteNo?quoteNo=${encodeURIComponent(quoteNo)}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                    }
                );

                const quoteJson = await quoteRes.json();

                // 3. Save single object to state
                setQuoteData(quoteJson.data[0] || null);

            } catch (err) {
                console.error("Failed PG Response fetch error:", err);
                await createApiLog({
                    PARTNER_ID: PARTNER_ID,
                    APP_ID: 1,
                    COB: "MOTOR",
                    TRANS_ID: quoteData?.TRANS_ID,
                    API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/payments/payment-responses?br=${encodeURIComponent(br)}`,
                    REQUEST: br,
                    REQUEST_STATUS: "Failed",
                    RESPONSE: err,
                })
            }
        };

        fetchFailedPaymentResponse();
    }, []);

    const updateMotorquotes = async () => {
        const { mer_param_2 } = pgFailedData
        const data = {
            quoteNo: mer_param_2,
            quoteStatus: "QUOTE_GENERATED",
            paymentStatus: 'PAYMENT_CANCELLED',
            policyNo: ''
        }
        try {
            const token = await getValidAccessToken();
            const encrypted = await encryptRSA(data)
            const response = await axios.put(`${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`, encrypted,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

            // const updatedData = {...formData,userId : response.data.userId}
            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteData?.TRANS_ID,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
                REQUEST: data,
                REQUEST_STATUS: "Success",
                RESPONSE: response,
            })

            return response.data
        } catch (error) {
            console.error('Error posting data:', error);

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteData?.TRANS_ID,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
                REQUEST: data,
                REQUEST_STATUS: "Failed",
                RESPONSE: error,
            })
        }
    }

    useEffect(() => {
        const fetchTransactionDetails = async () => {
            const { mer_param_2 } = pgFailedData;
            if (!mer_param_2) {
                console.warn("Missing quote number");
                return;
            }

            const searchQuoteRequest = getTransDtls({ quoteNo: mer_param_2, txnTyp: "Q", srcBusId: SRC_BUS_ID });

            try {
                dispatch({ type: "LOADING", payload: true });

                const searchQuoteResponse = await fetch(`${process.env.REACT_APP_GET_TRANS_DTLS}`, {
                    method: "POST",
                    headers: { "Content-Type": "text/xml" },
                    body: searchQuoteRequest,
                });

                const responseText = await searchQuoteResponse.text();

                await createApiLog({
                    PARTNER_ID: PARTNER_ID,
                    APP_ID: 1,
                    COB: "MOTOR",
                    TRANS_ID: quoteData?.TRANS_ID,
                    API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
                    REQUEST: searchQuoteRequest,
                    REQUEST_STATUS: "Success",
                    RESPONSE: responseText,
                })

                await updateJourneyLog({
                    TRANS_ID: quoteData?.TRANS_ID,
                    JOURNEY_STATUS: "PAYMENT_CANCELLED",
                    REMARKS: 'Payment was cancelled'
                })

                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(responseText, "text/xml");
                const transDtls = getTransDtlsSoap(xmlDoc)
                const resultUpdateQuote = await updateMotorquotes();

                SetTransDtls(transDtls)
            } catch (error) {
                await createApiLog({
                    PARTNER_ID: PARTNER_ID,
                    APP_ID: 1,
                    COB: "MOTOR",
                    TRANS_ID: quoteData?.TRANS_ID,
                    API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
                    REQUEST: searchQuoteRequest,
                    REQUEST_STATUS: "Failed",
                    RESPONSE: error,
                })
                console.error("Error fetching transaction details:", error);
            } finally {
                dispatch({ type: "LOADING", payload: false });
            }
        };

        if (pgFailedData && quoteData) {
            fetchTransactionDetails();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pgFailedData, quoteData]);

    const handleHome = () => {
        navigate('/');
    };

    return (
        <>
            {loading && <LoadingMask />}
            <div className="container">
                {/* Section Header */}
                <div className="row mb-2">
                    <div className="col-md-12">
                        <SectionHeader title="Motor Insurance " stepNo={3} totalStep={3} failedStep={3} />
                    </div>
                </div>
                <div className="container bg-white">
                    <div className="row mt-2 d-flex justify-content-center">
                        <div className="col-md-1 mt-3 d-flex ms-auto">
                            <button className="btn btn-secondary btn-sm" onClick={handleHome} style={{ padding: "4px 10px" }}>
                                Home
                            </button>
                        </div>
                        <div className="col-md-12 mt-5 d-flex justify-content-center">
                            <img src={redXIcon} alt="redtickicon" className="img-fluid" />
                        </div>
                        <div className="col-md-12 mt-2 d-flex justify-content-center">
                            <label className='payment-success-label'>Sorry. Payment transaction failed!</label>
                        </div>
                        <div className="col-md-12 mt-2 d-flex justify-content-center">
                            <label className='thank-you-label'>Please try again later.</label>
                        </div>

                        <div className="col-md-12 mt-3 mb-1"></div>
                        {/* <div className="col-md-12 mt-5 mb-5"></div>  */}

                        <div class="card shadow-sm rounded-4 p-4" style={{ maxWidth: "400px" }}>
                            <h5 class="fw-semibold mb-4">Quote Details</h5>

                            <div class="mb-2 d-flex justify-content-between">
                                <span class="text-muted">Quote No</span>
                                <span class="fw-medium">{pgFailedData?.mer_param_2}</span>
                            </div>

                            <div class="mb-2 d-flex justify-content-between">
                                <span class="text-muted">Insured Name</span>
                                <span class="fw-medium">{transDtls?.insuredName}</span>
                            </div>

                            <div class="mb-2 d-flex justify-content-between">
                                <span class="text-muted">Insurance Type</span>
                                <span className="fw-medium">
                                    {transDtls?.productType}
                                </span>
                            </div>
                        </div>
                        <div className="col-md-12 mt-3 mb-1"></div>

                        <div className="row mt-2 mb-5">
                            <div className="col-md-4"></div>

                            <div className="col-md-4 need-help-section ps-4">
                                <div className="row">

                                    {/* Need Help Section */}
                                    <div className="col-md-12 mt-2">
                                        <label className="need-help-label">Need Help?</label>
                                    </div>

                                    {/* Chat with Us */}
                                    <div className="col-md-5 mb-3">
                                        <div className="d-flex align-items-center mt-3">
                                            <img src={chatUs} alt="chat" />
                                            <div className="d-flex flex-column ms-2  lh-sm">
                                                <label className="chat-us-label mb-0">CHAT WITH US</label>
                                                <span className="grey-label mt-0">Click here</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Call us on our helpline */}
                                    <div className="col-md-7 mb-3">
                                        <div className="d-flex align-items-center mt-3">
                                            <img src={call} alt="chat" />
                                            <div className="d-flex flex-column ms-2  lh-sm">
                                                <label className="chat-us-label mb-0">CALL US ON OUR HELPLINE</label>
                                                <span className="grey-label mt-0">8000 77 77</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="col-md-4"></div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
